module.exports = function getResource(label, vars = []) {
    let resources = {
        buyWith: 'Acheter avec'
    };

    return resources[label];
};
